module.exports = __webpack_public_path__ + "img/pills.c5317689.svg";